var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89897e-05 21.9583V6.375C8.89897e-05 2.86667 2.86676 0 6.37509 0H21.9584C25.4668 0 28.3334 2.86667 28.3334 6.375V21.9583C28.3334 25.4667 25.4668 28.3333 21.9584 28.3333H6.37509C2.86676 28.3333 8.89897e-05 25.4667 8.89897e-05 21.9583ZM8.22509 11.525H10.9668V20.3417H8.22509V11.525ZM9.60009 7.15001C10.4751 7.15001 11.1918 7.85834 11.1918 8.73334C11.1918 9.60834 10.4834 10.325 9.60009 10.325C8.71676 10.325 8.00842 9.60834 8.00842 8.73334C8.00842 7.85834 8.71676 7.15001 9.60009 7.15001ZM15.3168 11.525H12.6918H12.6751V20.35H15.4168V15.9917C15.4168 14.8417 15.6334 13.725 17.0584 13.725C18.4668 13.725 18.4834 15.0333 18.4834 16.0583V20.3417H21.2251V15.5083C21.2251 13.1333 20.7168 11.3083 17.9418 11.3083C16.6084 11.3083 15.7168 12.0417 15.3501 12.7333H15.3168V11.525Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d5a2f826e0c5ddcf784401390adc3d08.svg";
export { ForwardRef as ReactComponent };